import { ImageWithMetadata, Presentation } from '@features/powerpoint';
import { navigatingComplexityBackground, titleBackground } from '../images';
import {
  COVER_SLIDE,
  DEFAULT_FONT,
  NAVIGATING_COMPLEXITY_SLIDE,
  TITLE_SLIDE_MASTER,
} from './constants';
import { slideMaster } from '../slides/slide-master';

const SLIDE_WIDTH = 13.33;
const SLIDE_HEIGHT = 7.5;
const LAYOUT = 'CUSTOM_WIDESCREEN';

export const createSharedPresentationConfig = (
  brandLogo: ImageWithMetadata | null
): Presentation => {
  return {
    slideMasters: [
      {
        title: TITLE_SLIDE_MASTER,
        background: { path: titleBackground },
      },
      slideMaster({ brandLogoWithMetadata: brandLogo }),
      slideMaster({
        brandLogoWithMetadata: brandLogo,
        masterName: NAVIGATING_COMPLEXITY_SLIDE,
        backgroundPath: navigatingComplexityBackground,
      }),
      slideMaster({
        masterName: COVER_SLIDE,
        showHeader: false,
      }),
    ],
    layout: {
      name: LAYOUT,
      width: SLIDE_WIDTH,
      height: SLIDE_HEIGHT,
    },
    theme: { headFontFace: DEFAULT_FONT, bodyFontFace: DEFAULT_FONT },
  };
};
